export default __webpack_public_path__ + "static/media/pv-5.a1649ce4.png";